<template>
  <section class="section section--about" id="about">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 10" preserveAspectRatio="none">
      <polygon points="100 0 100 10 0 10" />
    </svg>

    <div class="section__inner">
      <div class="block">
        <a class="pre" href="#about">
          <span>#2</span>Building
        </a>
        <h2>
          Snowie has been a player of agile scrum teams, startup companies &
          also worked independenly as a freelancer creating web applications.
        </h2>
        <p class="lead">
          She loves painting the internet with css & tries to make the web a
          pleasant place for everyone.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss">
.section--about {
  background-color: $theme3;
  color: white;

  svg {
    fill: $theme3;
  }
}
</style>
